/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Fragment } from 'react';
import * as Types from '../../global/types';
import { Button, Link } from '@zapier/design-system';
import {
  CTAType,
  useTrackEvent,
  useAvroTracking,
  EventName,
  CtaGoalType,
  CtaNameType,
} from '../../observability';
import {
  hiddenOnMobile,
  VisibleOnlyOnMobile,
} from '../../utils/getResponsiveStyles';

export const CTA = ({
  ctaGoal,
  ctaName,
  ctaHref,
  ctaStyle = 'primary',
  ctaText,
}: {
  ctaHref: string;
  ctaGoal: CtaGoalType;
  ctaName: CtaNameType;
  ctaStyle?: Types.CtaStyleType;
  ctaText: string;
}) => {
  const trackEvent = useTrackEvent();
  const { emitCTAClickEvent } = useAvroTracking();

  const ctaProps = {
    color: ctaStyle,
    href: ctaHref,
    isFullWidth: false,
  };

  const handleClick = () => {
    emitCTAClickEvent({
      text: ctaText,
      href: ctaHref,
      section: 'Block',
      type: isTertiary ? CTAType.cta_link : CTAType.cta_button,
    });
    trackEvent(EventName.CALL_TO_ACTION, {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: ctaName,
      cta_raw_text: ctaText,
      cta_goal: ctaGoal,
      link_destination: ctaHref,
    });
  };

  const isTertiary = ctaStyle === Types.CtaStyle.tertiary;

  return (
    <Fragment>
      {isTertiary ? (
        <Link
          data-testid="cta-block"
          href={ctaHref}
          onClick={handleClick}
          weight="bold"
        >
          {ctaText}
        </Link>
      ) : (
        <Fragment>
          <div css={hiddenOnMobile}>
            <Button data-testid="cta-block" onClick={handleClick} {...ctaProps}>
              {ctaText}
            </Button>
          </div>
          <VisibleOnlyOnMobile>
            <Button
              data-testid="cta-block"
              onClick={handleClick}
              size="small"
              {...ctaProps}
            >
              {ctaText}
            </Button>
          </VisibleOnlyOnMobile>
        </Fragment>
      )}
    </Fragment>
  );
};
